import {
    GET_ATECO_START,
    GET_ATECO_ERROR,
    GET_ATECO_SUCCESS
  } from "../actions/business.js";
  
  const defaultState = {
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: "",
      },
    },
    result: null
  };
  
  export function ateco(state = defaultState, { type, payload, error }) {
    switch (type) {
      case GET_ATECO_START:
        return {
          status: {
            started: true,
            error: false,
            ended: false,
          },
        };
      case GET_ATECO_SUCCESS:
        return {
          status: {
            started: false,
            error: false,
            ended: true,
          },
          result : payload
        };
      case GET_ATECO_ERROR:
        return {
          status: {
            started: false,
            error: true,
            ended: false,
            errorInfo: { error },
          },
        };
      
      default:
        return state;
    }
  }